
import React, { useEffect } from 'react';
import { useLanguage } from "@/hooks/useLanguage";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { NewsListItem } from "./NewsListItem";
import { Newspaper } from "lucide-react";
import { NewsItem } from '@/types/dashboard';
import { Link } from 'react-router-dom';

interface NewsCardProps {
  news: NewsItem[];
  isLoading: boolean;
}

export function NewsCard({ news, isLoading }: NewsCardProps) {
  const { t, language } = useLanguage();

  console.log("NewsCard rendered:", {
    language,
    newsCount: news?.length || 0,
    isLoading,
    sample: news && news.length > 0 ? news[0].title : 'no news'
  });

  return (
    <Card className="border-border/50 h-full bg-card/50 backdrop-blur-sm hover:shadow-lg transition-all duration-300 hover:border-primary/50">
      <CardHeader className="pb-2">
        <CardTitle className="text-xl flex items-center">
          <div className="p-2 rounded-lg bg-primary/10 mr-3 group-hover:bg-primary/20 transition-colors">
            <Newspaper className="h-5 w-5 text-primary" />
          </div>
          <Link to="/news" className="hover:text-primary transition-colors flex-1">
            {t('dashboard.latest_news')}
          </Link>
        </CardTitle>
      </CardHeader>
      <CardContent>
        {isLoading ? (
          <div className="space-y-4">
            {[...Array(5)].map((_, i) => (
              <div key={i} className="flex flex-col gap-2">
                <div className="h-5 w-3/4 bg-secondary/50 animate-pulse rounded-md" />
                <div className="h-4 w-1/4 bg-secondary/30 animate-pulse rounded-md" />
              </div>
            ))}
          </div>
        ) : news && news.length > 0 ? (
          <div className="space-y-4">
            {news.map((newsItem: NewsItem, index: number) => (
              <a
                key={`${language}-news-${index}`}
                href={newsItem.link}
                target="_blank"
                rel="noopener noreferrer"
                className="block group/item"
              >
                <NewsListItem news={newsItem} />
              </a>
            ))}
          </div>
        ) : (
          <p className="text-muted-foreground text-sm">{t('common.no_results')}</p>
        )}
      </CardContent>
    </Card>
  );
}
